import { render, staticRenderFns } from "./PayrollPreview.vue?vue&type=template&id=395ea112&scoped=true&"
import script from "./PayrollPreview.vue?vue&type=script&lang=js&"
export * from "./PayrollPreview.vue?vue&type=script&lang=js&"
import style0 from "./PayrollPreview.vue?vue&type=style&index=0&id=395ea112&lang=scss&scoped=true&"
import style1 from "./PayrollPreview.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395ea112",
  null
  
)

export default component.exports